/**
 * Home Page
 */

import React from 'react';

import { Button } from '@/components/ui/button';
import { Card, CardDescription,CardHeader, CardTitle } from '@/components/ui/card';

export const HomePage: React.FC<{ onNavigate: (to: string) => void }> = ({ onNavigate }) => {
  return (
    <div className="h-full overflow-auto">
      <div className="max-w-5xl mx-auto p-8">
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-semibold">SWE DevTools</h1>
          <span className="px-2 py-0.5 rounded text-xs font-medium border border-border bg-muted/30 text-muted-foreground">
            Beta
          </span>
        </div>
        <p className="text-muted-foreground mt-2">
          Beta testing is in progress. Choose a workspace to begin.
        </p>

        <div className="mt-6 flex gap-2">
          <Button variant="outline" onClick={() => onNavigate('/tools')}>Go to Tools</Button>
          <Button variant="default" onClick={() => onNavigate('/editor')}>Open Editor</Button>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="bg-muted/20">
            <CardHeader className="p-4">
              <CardTitle className="text-base">Home</CardTitle>
              <CardDescription>Quick links and status.</CardDescription>
            </CardHeader>
          </Card>
          <Card className="bg-muted/20">
            <CardHeader className="p-4">
              <CardTitle className="text-base">Tools</CardTitle>
              <CardDescription>Browse and launch tools.</CardDescription>
            </CardHeader>
          </Card>
          <Card className="bg-muted/20">
            <CardHeader className="p-4">
              <CardTitle className="text-base">Editor</CardTitle>
              <CardDescription>Single tool or pipeline mode.</CardDescription>
            </CardHeader>
          </Card>
        </div>
      </div>
    </div>
  );
};
